import { render, staticRenderFns } from "./RegisterVue.vue?vue&type=template&id=70351773&scoped=true"
import script from "./RegisterVue.vue?vue&type=script&lang=js"
export * from "./RegisterVue.vue?vue&type=script&lang=js"
import style0 from "./RegisterVue.vue?vue&type=style&index=0&id=70351773&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70351773",
  null
  
)

export default component.exports